export enum NumberFormatNegativeFormat {
    PARENTHESES = "parentheses",
    MINUS_LEFT = "minus-left",
    MINUS_RIGHT = "minus-right",
}

export enum NumberFormatZeroDisplay {
    DASH = "dash",
    BLANK = "blank",
    ZERO = "zero",
}

export enum NumberFormatCurrencySymbol {
    NONE = "none",
    DOLLAR = "$",
    US_DOLLAR = "US$",
    USD = "USD",
}

export enum NumberFormatAmountScale {
    FULL = "full",
    THOUSANDS = "thousands",
    MILLIONS = "millions",
}

export enum NumberFormatCurrencyPlacement {
    ALL_ROWS = "all_rows",
    COLUMN_HEADERS = "column_headers",
}
